var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell app-table__cell-header",class:[
       _vm.cell.prop,
       _vm.cell.propType,
       { 'hide-mobile': _vm.cell.mobileHide }
     ]},[_c('div',{staticClass:"app-table__cell-content",class:[
         _vm.cell.propType,
         {
           'active': _vm.sortingData.prop === _vm.cell.prop && _vm.sortingData.direction !== _vm.sortDirection.Default,
           'without-sorting': _vm.disableSorting,
         }
       ],on:{"click":function($event){return _vm.setSorting()}}},[_c('div',{staticClass:"app-table__th-title"},[_c('div',{staticClass:"app-table__th-label",domProps:{"innerHTML":_vm._s(_vm.cell.label)}}),_c('div',{staticClass:"app-table__th-info"},[(_vm.cell.tooltip)?_c('el-tooltip',{attrs:{"content":_vm.cell.tooltip,"effect":"light","placement":"bottom","open-delay":600}},[_c('i',{staticClass:"el-icon-info"})]):_vm._e()],1)]),(!_vm.disableSorting)?_c('div',{staticClass:"app-table__th-sorting"},[_c('i',{class:(_vm.sortingData.prop === _vm.cell.prop && _vm.sortingData.direction === _vm.sortDirection.Up)
        || _vm.sortingData.prop !== _vm.cell.prop
          ? 'el-icon-top'
          : 'el-icon-bottom'})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }